import * as globals from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {IconAddNew} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

export const Subheader = styled.div<{reduceMarginTop?: boolean}>`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  line-height: 18px;
  margin-bottom: 8px;
  ${props =>
    props.reduceMarginTop &&
    css`
      margin-top: -12px;
    `}
`;
export const ContactUsWrapper = styled.div`
  display: flex;
  color: ${globals.MOON_500};
`;
export const ContactUsText = styled(TargetBlank)`
  cursor: pointer;
  color: ${globals.TEAL_550};
  margin-right: 3px;
  &:hover {
    color: ${globals.TEAL_600};
  }
`;

export const NextBillingDateWrapper = styled.div`
  color: ${globals.MOON_650};
  font-weight: 400;
`;
export const BillingDateBold = styled.span`
  font-weight: 600;
`;

export const SubtitleWrapper = styled.div`
  font-size: 18px;
  line-height: 32px;
  color: ${globals.MOON_800};
  margin-bottom: 8px;
`;
export const SubtitleBoldText = styled.span`
  font-size: 20px;
  font-weight: 600;
`;
export const SubtitleGrayText = styled.div`
  color: ${globals.MOON_600};
`;

export const DescriptionList = styled.div`
  margin-left: 4px;
  margin-bottom: 8px;
  color: ${globals.MOON_600};
  padding: 0;
  font-size: 14px;
  font-weight: 400;
`;
export const DescriptionListItem = styled.li`
  line-height: 20px;
  &&&& {
    padding: 0;
    align-items: baseline;
  }
`;

export const DescriptionDetails = styled.div`
  margin-top: 4px;
  font-size: 14px;
  line-height: 18px;
`;

const BaseCTAButton = styled.div`
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  height: 30px;
  padding: 3px 12px;
  &:not(:last-child) {
    margin-right: 12px;
  }
  align-text: center;
`;

export const PrimaryCTAButton = styled(BaseCTAButton)`
  background-color: ${globals.TEAL_500};
  color: ${globals.WHITE};
`;
export const SecondaryCTAButton = styled(BaseCTAButton)`
  background-color: ${globals.MOON_200};
  color: ${globals.MOON_800};
`;

export const PrimaryCTATargetBlank = styled(TargetBlank)`
  color: ${globals.WHITE};
  font-weight: 600;
  &:hover {
    color: ${globals.WHITE};
  }
`;
export const IconAdd = styled(IconAddNew)`
  margin-right: 2px;
  height: 19px;
`;

export const NoticeContainer = styled.div`
  background-color: ${globals.MOON_50};
  font-size: 12px;
  min-height: 16px;
  padding: 12px;
  width: fit-content;
  line-height: 16px;
  border-radius: 6px;
`;

export const NoticeContainerBoldText = styled.div`
  font-weight: 600;
`;

export const NoticeContainerText = styled.div``;
